"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INIT_FAILURE = exports.INIT_SUCCESS = exports.INIT_REQUEST = undefined;
exports.initSuccess = initSuccess;
exports.initialize = initialize;

var _api = require("../middleware/api");

var _locale = require("../locale");

var _locale2 = _interopRequireDefault(_locale);

var _reactGa = require("react-ga");

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIT_REQUEST = exports.INIT_REQUEST = "INIT_REQUEST";
var INIT_SUCCESS = exports.INIT_SUCCESS = "INIT_SUCCESS";
var INIT_FAILURE = exports.INIT_FAILURE = "INIT_FAILURE";

function initSuccess() {
  return {
    type: INIT_SUCCESS
  };
}

function initialize(configId) {
  return function (dispatch) {
    var startTime = new Date();
    var action = dispatch(_defineProperty({}, _api.CALL_API, {
      types: [INIT_REQUEST, INIT_SUCCESS, INIT_FAILURE],
      endpoint: "/apps/hpmodule/" + configId,
      method: "GET",
      content: "application/de.servicelister.api.v1+json; charset=utf-8",
      query: {
        Country: "DE",
        Language: "de"
      }
    }));
    action.then(function (response) {
      _locale2.default.setResources(response.data.Locale);

      if (response.data.TrackingId) {
        _reactGa2.default.initialize(response.data.TrackingId, {
          debug: true
        });

        _reactGa2.default.timing({
          category: "OTB",
          variable: "Initialization Request",
          value: new Date() - startTime
        });
      }
    }, function () {
      throw "Can't set translations";
    });
    return action;
  };
}